import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useErrorDialog } from '@/app/common/context/ErrorDialogContext.tsx';

export function ApiErrorDialog() {
  const { state, closeErrorDialog } = useErrorDialog();
  const [detailOpen, setDetailOpen] = useState(false);
  const [retrying, setRetrying] = useState(false);

  useEffect(() => {
    if (!state.open) {
      setDetailOpen(false);
      setRetrying(false);
    }
  }, [state.open]);

  const handleClose = () => {
    if (retrying) return;
    closeErrorDialog();
  };

  const handleRetry = async () => {
    if (!state.onRetry) return;
    setRetrying(true);
    try {
      await state.onRetry();
      closeErrorDialog();
    } catch {
      // retry selhal
    } finally {
      setRetrying(false);
    }
  };

  return (
    <Dialog open={state.open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Operace se nezdařila</DialogTitle>
      <DialogContent>
        <Typography>{state.label} se nezdařilo.</Typography>
        <Typography color="text.secondary" sx={{ mt: 0.5 }}>
          Zkontrolujte připojení a zkuste to znovu.
        </Typography>
        {state.errorDetail && (
          <>
            <Button
              size="small"
              sx={{ mt: 1.5, p: 0, minWidth: 0, textTransform: 'none', color: 'text.secondary' }}
              onClick={() => setDetailOpen((v) => !v)}
            >
              {detailOpen ? '▾' : '▸'} Technické detaily
            </Button>
            <Collapse in={detailOpen}>
              <Typography
                variant="caption"
                component="pre"
                sx={{ mt: 1, p: 1.5, display: 'block', bgcolor: 'grey.100', borderRadius: 1, whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontFamily: 'monospace' }}
              >
                {state.errorDetail}
              </Typography>
            </Collapse>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={retrying}>Zavřít</Button>
        {state.onRetry && (
          <Button variant="contained" onClick={handleRetry} disabled={retrying}>
            {retrying ? 'Opakuji…' : 'Zkusit znovu'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
